import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import TalukaTable from './table/js/talukaTable';
import TalukaCreate from './create/js/talukaCreate';
import PropTypes from 'prop-types';

function TalukaManagement() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="eduss-taluka-management" style={{ padding: '20px' }}>
      <TalukaTable 
        onCreateTaluka={() => setShowCreateModal(true)} 
        reloadKey={reloadKey}
      />

      {/* Create Taluka Modal */}
      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal large eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New Taluka</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <TalukaCreate
                onClose={() => setShowCreateModal(false)}
                onSubmit={() => { setReloadKey(p => p + 1); setShowCreateModal(false); }}
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

TalukaManagement.propTypes = {
  initialTab: PropTypes.string,
};

export default TalukaManagement;
